import { TRemindPasswordType } from '../../actions/remindPassword';

export const REMIND_PASSWORD_TYPE: TRemindPasswordType = 'remindPassword/status_changed';
